// extracted by mini-css-extract-plugin
module.exports = {"realCheckbox":"src-hellospa-foundation-control-checkbox-checkbox__realCheckbox--1ux_u","svgLabel":"src-hellospa-foundation-control-checkbox-checkbox__svgLabel--1ynYU"};